import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Hive extends Component {
    constructor(props) {
        super(props);
        
        (function(h, i, v, e, s, d, k) {
            h.HiveSDKObject = s;
            h[s] = h[s] || function() {
                (h[s].q = h[s].q || []).push(arguments)
            },
            d = i.createElement(v),
            k = i.getElementsByTagName(v)[0];
            d.async = 1;
            d.id = s;
            d.src = e + '?r=' + parseInt(new Date() / 60000);
            k.parentNode.insertBefore(d, k)
        })(window, document, 'script', 'https://cdn-prod.hive.co/static/js/sdk-loader.js', 'HIVE_SDK');
        
        HIVE_SDK('init', props.config.id);
    }

    render() {
        return null;
    }
}

Hive.propTypes = {
    config: PropTypes.object.isRequired,
};
